// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App.vue'

//vuex
import store from './vuex/store.js';

//router
import VueRouter from 'vue-router';
import routers from './routers.js'

//element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

//vue-video-player
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
import VueVideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');
import 'videojs-flash'
import 'videojs-contrib-hls'

import md5 from 'js-md5';

//个人样式及脚本
import './static/css/public.css';
import './static/css/style.css';
import './static/css/loading.css';
import selfjs from './static/js/javascript.js';

//全局变量
import global_ from './Global.vue'//引用文件

// 引入模板文件
Vue.prototype.temp = store.state.template
import temp_change from './static/js/template/temp_change';

//axios
// import axios from 'axios'
import qs from 'qs'
import ajax from './common/ajax'
// 设置公共请求前缀
// export const baseUrl = 'localhost:8080';
// axios.defaults.baseURL = baseUrl;

//vue-cookies
import VueCookies from 'vue-cookies';
// cookie设置3个月过期
VueCookies.config('3m')

// 添加moment
import moment from 'moment'
Vue.prototype.$moment = moment

Vue.use(ElementUI);
Vue.use(VueCookies);
// Vue.use(VueAwesomeSwiper);
Vue.use(VueVideoPlayer);
Vue.use(VueRouter);
Vue.prototype.$selfjs = selfjs;
Vue.prototype.global = global_;
Vue.prototype.nodataImg = window.location.protocol+'//oss.gzxsen.com/gzxsen.com/pc/images/nodata.png';
Vue.prototype.$ajax = ajax;
Vue.prototype.$qs = qs;
Vue.prototype.$md5 = md5;
Vue.config.productionTip = false

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

//关于 HTML5 history 模式的更多内容，可以参考官方文档：https://router.vuejs.org/zh-cn/essentials/history-mode.html
const router = new VueRouter({
  // mode: 'history'
  routes: routers.router
})
//路由跳转前
router.beforeEach((to, from, next) => {
	function join(router){
		/* 路由发生变化修改页面title */
		let client_type = selfjs.getParamString('client-type')
		// && !client_type.includes("qs-app")
		if (to.meta.title && !client_type ) {
			document.title = to.meta.title + store.state.titleAfter
		}
		if (router) {
			next(router)
		}else{
			next()
		}
		
	}
	let token=VueCookies.get("token")
	// let waptoken=selfjs.getToken()
	// console.log(VueCookies.keys().join("\n"))
	// console.log(waptoken)
	// console.log(to)
	// console.log(from)

	// 白名单页不跳转
	let hash = window.location.hash
	let page_whitelist = global_.page_whitelist
	for(let p = 0; p < page_whitelist.length; p++){
		let page = page_whitelist[p]
		if(hash.indexOf(page) > -1){
			// 直播页打开游客模式
			// if(hash.indexOf("/web/live/room") > -1){
				store.state.visitor = true
			// }
			console.log('白名单页');
			join()
			return false;
		}else{
			store.state.visitor = false
		}
	}
	store.dispatch('get_identity_list')
	store.dispatch('get_app_config').then(res=>{
        //获取是否密码过期
		store.dispatch('get_is_expire')
		// if (res.platform_code=='platform.dyy') {
		// 	global_.titleAfter = ' - 电子科技大学广东信息工程研究院 - 专业技术人员继续教育网络平台'
		// 	store.commit("research_institute", true)
		// }else{
		// 	store.commit("research_institute", false)
		// }
		store.commit("change_vuex", {
			key: 'app_config_load',
			value: false
		})
		switch(res.platform_code){
			case "gzxsen.com":
				// that.$store.commit("research_institute", false)
				store.commit("change_vuex",{
					key: "titleAfter",
					value: ' - 学业水平综合培训'
				})
				temp_change.xuexi_qsxueli()
				break;
		}
	})



    if(token==null){
		if(to.name!='login'){
			window.location.href="/web/"
		}
	}else if(token==""){
		Vue.prototype.$message.error("登录过期，请重新登录！");
		// $message.error("登录过期，请重新登录！");
		// selfjs.loginOutFn(this, "route")
		VueCookies.remove("token");
		window.location.href="/web/"
		return false;
    }
	
	// if (to.fullPath=='/web/login/'||to.fullPath=='/web/user_detail') {
	// 	join()
	// 	// return false
	// }else{
	// 	store.dispatch('get_user_relation_count').then(res=>{
	// 		console.log(res);
	// 		// join()
	// 		if (res.register_count==0) {
	// 			// store.commit("defaultIndex",'user_detail')
	// 			// join('/web/user_detail')
	// 			window.location.href="/#/web/user_detail"
	// 			// console.log(66);
	// 		}else{
	// 			// join()
	// 		}
	// 		join()
	// 	})
	// }
	
	
	
	// 执行路由跳转
	join()
})
//路由跳转后
router.afterEach((to, from, next) => {
	// console.log(waptoken)
	// console.log(this)
})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
	//components: { App },
	//template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js